'use es6';

import { APPLICATION_SETTINGS_USER_SAVE } from 'DesignData/actions/ActionTypes';
import * as api from 'DesignData/api/settings/User';
import { getUserSettings } from 'DesignData/selectors/userSettings';
import { getUserId } from 'DesignData/selectors/auth';

const createUserSettingsMessageHandlers = type => {
  return {
    receive: options => ({
      type,
      options
    }),
    error: error => ({
      type,
      error
    })
  };
};
/**
 * Save User Settings
 */


export function saveUserSettings() {
  const {
    receive,
    error
  } = saveUserSettings;
  return (dispatch, getState) => {
    const state = getState();
    const userId = getUserId(state);
    const userSettings = getUserSettings(state);
    api.saveUserSettings(userId, userSettings).then(() => dispatch(receive(userSettings))).catch(__error => dispatch(error(__error)));
  };
}
Object.assign(saveUserSettings, createUserSettingsMessageHandlers(APPLICATION_SETTINGS_USER_SAVE));